import { Component, OnInit } from "@angular/core";
import {
    Location,
    PopStateEvent,
} from "@angular/common";
import { Router, NavigationEnd, NavigationStart } from "@angular/router";
import PerfectScrollbar from "perfect-scrollbar";
import $ from "jquery";
import { filter, firstValueFrom, Subscription } from "rxjs";
import { StatusService } from "app/modules/core/services/user/status.service";
import { GeneralConstants } from "app/modules/core/services/constants";

@Component({
    selector: "app-admin-layout",
    templateUrl: "./admin-layout.component.html",
    styleUrls: ["./admin-layout.component.scss"],
    standalone: false
})
export class AdminLayoutComponent implements OnInit {
    private _router: Subscription;
    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];

    constructor(public location: Location, private router: Router, private statusSvc: StatusService) { }

    ngOnInit() {
        const body = document.getElementsByTagName("body")[0];
        body.classList.remove("nav-open");

        // Load sidebar state
        const isMini = localStorage.getItem('sidebar-mini') === 'true';
        if (isMini) {
            body.classList.add('sidebar-mini');
        }

        const isWindows = navigator.platform.indexOf("Win") > -1 ? true : false;
        if (isWindows) {
            body.classList.add("perfect-scrollbar-on");
        }

        const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
        const elemSidebar = <HTMLElement>(
            document.querySelector(".sidebar .sidebar-scroll")
        );

        this.location.subscribe((ev: PopStateEvent) => {
            this.lastPoppedUrl = ev.url;
        });
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationStart) {
                if (event.url != this.lastPoppedUrl)
                    this.yScrollStack.push(window.scrollY);
            } else if (event instanceof NavigationEnd) {
                if (event.url == this.lastPoppedUrl) {
                    this.lastPoppedUrl = undefined;
                    window.scrollTo(0, this.yScrollStack.pop());
                } else window.scrollTo(0, 0);
            }
        });
        this._router = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                body.classList.remove("nav-open");
                if (elemMainPanel) elemMainPanel.scrollTop = 0;
                if (elemSidebar) elemSidebar.scrollTop = 0;
            });
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            if (elemMainPanel) new PerfectScrollbar(elemMainPanel);
            // Skip PerfectScrollbar on sidebar to allow flyout overflow
        }

        const window_width = $(window).width();
        let $sidebar = $(".sidebar");
        let $sidebar_responsive = $("body > .navbar-collapse");
        let $sidebar_img_container = $sidebar.find(".sidebar-background");

        if (window_width > 767) {
            if ($(".fixed-plugin .dropdown").hasClass("show-dropdown")) {
                $(".fixed-plugin .dropdown").addClass("open");
            }
        }

        $(".fixed-plugin a").click(function (event) {
            // Alex if we click on switch, stop propagation of the event, so the dropdown will not be hide, otherwise we set the  section active
            if ($(this).hasClass("switch-trigger")) {
                if (event.stopPropagation) {
                    event.stopPropagation();
                } else if (window.event) {
                    window.event.cancelBubble = true;
                }
            }
        });

        $(".fixed-plugin .badge").click(function () {
            let $full_page_background = $(".full-page-background");

            $(this).siblings().removeClass("active");
            $(this).addClass("active");

            var new_color = $(this).data("color");

            if ($sidebar.length !== 0) {
                $sidebar.attr("data-color", new_color);
            }

            if ($sidebar_responsive.length != 0) {
                $sidebar_responsive.attr("data-color", new_color);
            }
        });

        $(".fixed-plugin .img-holder").click(function () {
            let $full_page_background = $(".full-page-background");

            $(this).parent("li").siblings().removeClass("active");
            $(this).parent("li").addClass("active");

            var new_image = $(this).find("img").attr("src");

            if ($sidebar_img_container.length != 0) {
                $sidebar_img_container.fadeOut("fast", function () {
                    $sidebar_img_container.css(
                        "background-image",
                        'url("' + new_image + '")'
                    );
                    $sidebar_img_container.fadeIn("fast");
                });
            }

            if ($full_page_background.length != 0) {
                $full_page_background.fadeOut("fast", function () {
                    $full_page_background.css(
                        "background-image",
                        'url("' + new_image + '")'
                    );
                    $full_page_background.fadeIn("fast");
                });
            }

            if ($sidebar_responsive.length != 0) {
                $sidebar_responsive.css("background-image", 'url("' + new_image + '")');
            }
        });


        if (this.router.url == '"/main"') {
            this.router.navigate(['/main/dashboard']);
        }

        this.handlingRouting();
    }

    ngAfterViewInit() {
        this.runOnRouteChange();
    }

    isMaps(path) {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        titlee = titlee.slice(1);
        if (path == titlee) {
            return false;
        } else {
            return true;
        }
    }

    runOnRouteChange(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
            const ps = new PerfectScrollbar(elemMainPanel);
            ps.update();
        }
    }

    isMac(): boolean {
        let bool = false;
        if (
            navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
            navigator.platform.toUpperCase().indexOf("IPAD") >= 0
        ) {
            bool = true;
        }
        return bool;
    }

    toggleResponsiveSidebar(): void {
        document.body.classList.toggle("nav-open");
    }

    closeResponsiveSidebar(): void {
        document.body.classList.remove("nav-open");
    }

    isResponsiveSidebarOpen(): boolean {
        return document.body.classList.contains("nav-open");
    }

    async handlingRouting() {
        let parentPermissions = await firstValueFrom(this.statusSvc.getPermissionCodesParent());
        let childPermissions = await firstValueFrom(this.statusSvc.getPermissionCodesChild());
        let relatedPermission = null;

        // User is allowed to visit a page and should not be redirected to some other page if:
        // 1) The route has no related permissions
        for (let [key, value] of GeneralConstants.PermissionCodeForRoute) {
            if ((value.match == 'exact' && this.router.url == key) || (value.match == 'include' && this.router.url.includes(key))) {
                relatedPermission = value.permission;
            }
        }

        if (parentPermissions && childPermissions && relatedPermission) {
            // 2) The route has a related permission and user has that permission
            if (parentPermissions[relatedPermission] || childPermissions[relatedPermission]) return;

            for (let [key, value] of GeneralConstants.routesForPermissionCode) {
                if (parentPermissions[key] || childPermissions[key]) {
                    this.router.navigateByUrl(value);
                    break;
                }
            }
        }
    }
}
